import { Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ReportingNameEntity as ReportingNameEntity } from "../../../Data/MedicinalProductData/ReportingNameEntity";
import { DateUtil } from "../../../DateUtil";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { environment } from "../../../../../../environments/environment";
import { OnDemandNode } from "../../OnDemandNode";

export class TreeNodeReportingNameEntity extends OnDemandNode {

    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any) {
        super(injector, new ReportingNameEntity(injector,model), labelTemplate);
        this.parent=parent;
        this.ioc!.get(Art57Section).generateNumColumValue(this);
    }

    public getListItem(): any[] {
        return [this.data.model.ev_code, 
            this.data.model.productnamevariation, 
            this.ioc!.get(LookupGetService).retrieveValueFromCache('nameTypeProductIndex',this.data.model.type), 
            DateUtil.getDateTimeFormat(this.data.model.created_stamp), 
            this.data.model.stamp_nullif,
            this.ioc!.get(LookupGetService).retrieveValueFromCache('pispStatus',this.data.model.status) ,
            this.ioc!.get(LookupGetService).retrieveValueFromCache('binaryYesNo',this.data.model.full_presentation) ,
            this.ioc!.get(LookupGetService).retrieveValueFromCache('binaryYesNo',this.data.model.cap_flag) , 
            this.ioc!.get(LookupGetService).retrieveValueFromCache('binaryYesNo',this.data.model.is_substance),
            this.ioc!.get(LookupGetService).retrieveValueFromCache('binaryYesNo',this.data.model.show_in_lookup), 
            this.data.model.numref, 
            this.data.model.numsciref];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeReportingNameEntity = new TreeNodeReportingNameEntity(
        this.ioc!,
        this.labelTemplate,
        newParent,
        this.data.model
      );
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

        this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
// property doesn't exist     clonedNode.cloningNode = false;
     return clonedNode;
    }

}